import { render, staticRenderFns } from "./swipe.vue?vue&type=template&id=cc31b6c8&scoped=true"
import script from "./swipe.vue?vue&type=script&lang=js"
export * from "./swipe.vue?vue&type=script&lang=js"
import style0 from "./swipe.vue?vue&type=style&index=0&id=cc31b6c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc31b6c8",
  null
  
)

export default component.exports